'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isThreadComment = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this should be an operator on a pubsub message but schema shouldn't depend on internals
// see: https://zenhub.hubteam.com/app/workspace/o/hubspot/conversations-team/issues/2049
var isThreadComment = exports.isThreadComment = function isThreadComment(message) {
  return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, message) === _messageTypes.THREAD_COMMENT;
};